// @ts-nocheck

import React, { useMemo, forwardRef } from 'react';
import styled, { css } from 'styled-components';

import * as CommonIcons from '../../assets/svg/common';
import theme from '../../styled-components/dark';
import { type ToastrType, ToastrTypes } from '../../types/toastr';

const ToastrTypeAsIcon = {
  [ToastrTypes.SUCCESS]: CommonIcons.Valid,
  [ToastrTypes.ERROR]: CommonIcons.Alert,
  [ToastrTypes.INFO]: CommonIcons.Alert,
};

const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 0.75em 0.5em;

  opacity: 0.95;

  cursor: pointer;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  ${({ $type }) => css`
    background-color: ${theme.Toastr[$type]?.backgroundColor ?? theme.Toastr.FALLBACK.backgroundColor};
    color: ${theme.Toastr[$type]?.color ?? theme.Toastr.FALLBACK.color};
  `}
`;

const IconWrapper = styled.div`
  margin-right: 0.5em;

  display: flex;
  align-items: center;

  svg {
    width: 1.5em;
    height: 1.5em;
  }
`;

const MessageWrapper = styled.div``;

const Message = styled.span`
  font-size: 1em;
`;

type PropsType = {
  type: ToastrType;
  message: string;
  showIcon?: boolean;
  onClick: (...params: unknown) => unknown;
  className?: string;
};

const Toastr = forwardRef<PropsType, Wrapper>(function Toastr(props, ref) {
  const { type, message, showIcon = true, onClick = () => {}, className = '' } = props;
  const ToastrIcon = useMemo(() => ToastrTypeAsIcon[type], [type]);

  return (
    <Wrapper ref={ref} className={className} onClick={onClick} $type={type}>
      {showIcon && (
        <IconWrapper>
          <ToastrIcon />
        </IconWrapper>
      )}
      <MessageWrapper>
        <Message>{message}</Message>
      </MessageWrapper>
    </Wrapper>
  );
});

export default Toastr;
